<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M4 19v-2h2v-7q0-2 1.3-3.7 1.2-1.6 3.2-2.1V2h3v2.2q2 .5 3.3 2.1T18 10v7h2v2zm8 3a2 2 0 0 1-1.4-.6A2 2 0 0 1 10 20h4q0 .9-.6 1.4a2 2 0 0 1-1.4.6"
    />
  </svg>
</template>
